import { type ThemeConfig, theme } from 'antd';

const commonToken: Exclude<ThemeConfig['token'], undefined> = {
  colorPrimary: '#703EFF',
  fontSize: 12,
  borderRadius: 4,
  colorLink: '#2f65e2',
  colorTextDisabled: '#fff',
  colorBgContainerDisabled: 'rgba(112, 62, 255, 0.30)',
  fontFamily: `Manrope, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'`,
};

export const light: ThemeConfig = {
  token: {
    ...commonToken,
    colorText: '#425466',
    colorTextSecondary: '#6F767E',
    colorBorder: '#E1E6EF',
  },
  components: {
    Checkbox: {
      colorBorder: '#CCCCCC',
    },
    Button: {
      colorBorder: '#E2E8F0',
      borderRadius: 8,
    },
    Divider: {
      colorSplit: '#F1F5F9',
    },
    Table: {
      headerColor: '#8492A6',
    },
    Switch: {
      colorTextQuaternary: '#E1E1E1',
      handleBg: '#F7F7F7',
    },
    Badge: {
      indicatorHeight: 15,
      indicatorHeightSM: 14,
      colorBorderBg: 'transparent',
      colorError: '#FF3C3C',
      paddingXS: 4,
    },
    Modal: {
      borderRadiusLG: 8,
      titleColor: '#1a1a1a',
    },
    Tabs: {
      horizontalItemPadding: '10px 14px',
      horizontalItemGutter: 0,
      itemSelectedColor: '#703EFF',
      inkBarColor: '#703EFF',
      lineHeight: 1,
    },
    Notification: {
      borderRadiusLG: 12,
    },
    Select: {
      optionSelectedBg: 'rgba(112,60,255,0.1)',
      optionSelectedColor: 'rgb(112,62,255)',
    },
  },
  algorithm: theme.defaultAlgorithm,
};

export const dark: ThemeConfig = {
  token: {
    ...commonToken,
  },
  algorithm: theme.darkAlgorithm,
};
